import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GuildMarker from "../../tools/guildMarker";
import PanelFrame from "../../ui/PanelFrame";
import { useLang } from "../../../i18n/LangContext";
import rank1 from "../../../assets/imgs/ui/guild-ranks/rank-1.png";
import rank2 from "../../../assets/imgs/ui/guild-ranks/rank-2.png";
import rank3 from "../../../assets/imgs/ui/guild-ranks/rank-3.png";
import "./topGuilds.scss";

const RANK_MEDALS = [rank1, rank2, rank3];
const PLACEHOLDER_COUNT = 5;

const TopGuildSideBarLeft = () => {
  const guilds = useSelector((state) => state.reducerWeb.top5Guild);
  const navigate = useNavigate();
  const { t } = useLang();
  const rows = Array.isArray(guilds?.data) ? guilds.data.slice(0, 5) : [];
  const hasData = rows.length > 0;

  return (
    <PanelFrame title={t("top_guilds")} id="top-guilds">
      <div className="containerTopGuilds">
        <div className="mu-guild-podium">
          {hasData
            ? rows.slice(0, 3).map((guild, i) => (
                <button
                  type="button"
                  key={guild.G_Name || i}
                  className={`mu-guild-podium__slot mu-guild-podium__slot--${
                    i + 1
                  }`}
                  onClick={() => navigate(`/guild/${guild.G_Name}`)}
                >
                  <img
                    className="mu-guild-podium__medal"
                    src={RANK_MEDALS[i]}
                    alt={`Rank ${i + 1}`}
                  />
                  <GuildMarker mark={guild.G_Mark} size={22} />
                  <strong>{guild.G_Name}</strong>
                  <span>{t("score_label", { score: guild.Score })}</span>
                </button>
              ))
            : [0, 1, 2].map((i) => (
                <div
                  key={`podium-empty-${i}`}
                  className={`mu-guild-podium__slot mu-guild-podium__slot--${
                    i + 1
                  } mu-guild-podium__slot--empty`}
                >
                  <img
                    className="mu-guild-podium__medal"
                    src={RANK_MEDALS[i]}
                    alt={`Rank ${i + 1}`}
                  />
                  <strong>—</strong>
                  <span>{t("score_label", { score: "—" })}</span>
                </div>
              ))}
        </div>
        <table className="TopGuilds mu-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{t("col_guild")}</th>
              <th>{t("col_master")}</th>
              <th>{t("col_score")}</th>
            </tr>
          </thead>
          <tbody>
            {hasData
              ? rows.map((guild, i) => (
                  <tr key={`row-${guild.G_Name || i}`}>
                    <td>{i + 1}</td>
                    <td>
                      <span
                        className="newCursor topGuildName"
                        onClick={() => navigate(`/guild/${guild.G_Name}`)}
                      >
                        <GuildMarker mark={guild.G_Mark} size={20} />
                        {guild.G_Name}
                      </span>
                    </td>
                    <td
                      className="newCursor"
                      onClick={() => navigate(`/player/${guild.G_Master}`)}
                    >
                      {guild.G_Master}
                    </td>
                    <td>{guild.Score}</td>
                  </tr>
                ))
              : Array.from({ length: PLACEHOLDER_COUNT }).map((_, i) => (
                  <tr key={`guild-empty-${i}`} className="mu-row-placeholder">
                    <td>{i + 1}</td>
                    <td>—</td>
                    <td>—</td>
                    <td>—</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </PanelFrame>
  );
};

export default TopGuildSideBarLeft;
